import { render, staticRenderFns } from "./cantidad.vue?vue&type=template&id=c212d0b0&scoped=true&"
import script from "./cantidad.vue?vue&type=script&lang=ts&"
export * from "./cantidad.vue?vue&type=script&lang=ts&"
import style0 from "./cantidad.vue?vue&type=style&index=0&id=c212d0b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c212d0b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VProgressCircular,VRow,VTextField})
